var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGradientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.75H1.25C0.973437 0.75 0.75 0.973437 0.75 1.25V12.75C0.75 13.0266 0.973437 13.25 1.25 13.25H12.75C13.0266 13.25 13.25 13.0266 13.25 12.75V1.25C13.25 0.973437 13.0266 0.75 12.75 0.75ZM4.9375 9.875C4.59219 9.875 4.3125 9.59531 4.3125 9.25C4.3125 8.90469 4.59219 8.625 4.9375 8.625C5.28281 8.625 5.5625 8.90469 5.5625 9.25C5.5625 9.59531 5.28281 9.875 4.9375 9.875ZM4.9375 7.625C4.59219 7.625 4.3125 7.34531 4.3125 7C4.3125 6.65469 4.59219 6.375 4.9375 6.375C5.28281 6.375 5.5625 6.65469 5.5625 7C5.5625 7.34531 5.28281 7.625 4.9375 7.625ZM4.9375 5.375C4.59219 5.375 4.3125 5.09531 4.3125 4.75C4.3125 4.40469 4.59219 4.125 4.9375 4.125C5.28281 4.125 5.5625 4.40469 5.5625 4.75C5.5625 5.09531 5.28281 5.375 4.9375 5.375ZM9.6875 9.625C9.6875 9.69375 9.63125 9.75 9.5625 9.75H6.6875C6.61875 9.75 6.5625 9.69375 6.5625 9.625V8.875C6.5625 8.80625 6.61875 8.75 6.6875 8.75H9.5625C9.63125 8.75 9.6875 8.80625 9.6875 8.875V9.625ZM9.6875 7.375C9.6875 7.44375 9.63125 7.5 9.5625 7.5H6.6875C6.61875 7.5 6.5625 7.44375 6.5625 7.375V6.625C6.5625 6.55625 6.61875 6.5 6.6875 6.5H9.5625C9.63125 6.5 9.6875 6.55625 9.6875 6.625V7.375ZM9.6875 5.125C9.6875 5.19375 9.63125 5.25 9.5625 5.25H6.6875C6.61875 5.25 6.5625 5.19375 6.5625 5.125V4.375C6.5625 4.30625 6.61875 4.25 6.6875 4.25H9.5625C9.63125 4.25 9.6875 4.30625 9.6875 4.375V5.125Z",
    fill: "url(#paint0_linear_3401_6246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3401_6246",
    x1: 1.17155,
    y1: -3.86959,
    x2: 14.2435,
    y2: -3.46385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGradientIcon);
export default __webpack_public_path__ + "static/media/profile-gradient-icon.b01351f68dd554b01305d5e2df29bb4e.svg";
export { ForwardRef as ReactComponent };